import { Component, inject, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormGroup } from '@angular/forms';
import { AgreementPaymentForm } from '../../shared-agreement.model';
import { DropdownItem } from '@shared/components/dropdown/dropdown.component';
import { CachedValuesService } from '@services/cached-values';
import { ListTypeItem } from 'app/types/list-type-item.type';
import { Observable, map } from 'rxjs';
import { BaseHighlightComponent } from '@shared/components/base-highlight/base-highlight.component';

@UntilDestroy()
@Component({
    selector: 'app-agreement-payment',
    templateUrl: './payment.component.html',
    styleUrl: './payment.component.scss'
})
export class AgreementPaymentComponent extends BaseHighlightComponent {
    @Input() public paymentForm: FormGroup<AgreementPaymentForm>;
    @Input() public showPotentialValidationMessages: boolean;
    private readonly cachedValuesService = inject(CachedValuesService);

    public paymentTermsOptions: DropdownItem<number>[] = this.cachedValuesService.getPaymentTermsOptions();
    public invoiceIntervalsOptions: DropdownItem<number>[] = this.cachedValuesService.getInvoiceIntervalsOptions();
    public readonly currencies$: Observable<DropdownItem<string>[]> = this.cachedValuesService.currencies$.pipe(
        map((data) =>
            data.map((item: ListTypeItem) => {
                return {
                    value: item.name,
                    label: item.value
                } as DropdownItem<string>;
            })
        )
    );

    public get f() {
        return this.paymentForm.controls;
    }

    public showCustomPaymentTerms() {
        //return this.f.paymentTerms.value == -1;
        if (!this.f.paymentTerms.value) return false;
        if (this.f.paymentTerms.value == -1) return true;
        const result = this.paymentTermsOptions.find((p) => p.value == this.f.paymentTerms.value);
        if (result) {
            return false;
        }
        this.f.paymentTerms.setValue(-1);
        return true;
    }
}
